export default __webpack_public_path__ + "static/media/11-44.39925fcf.png";